<div class="flex flex-col h-full">
  <div class="flex flex-row gap-4">
    <div class="flex flex-col gap-4 flex-1">
      @for (detailField of detailFields().leftColumnFields; track detailField.field) {
        <ng-container
          *ngTemplateOutlet="detailFieldTemplate; context: { $implicit: detailField }"
        ></ng-container>
      }
    </div>
    <div class="flex flex-col gap-4 flex-1">
      @for (detailField of detailFields().rightColumnFields; track detailField.field) {
        <ng-container
          *ngTemplateOutlet="detailFieldTemplate; context: { $implicit: detailField }"
        ></ng-container>
      }
    </div>
  </div>

  <div
    class="mt-10 flex flex-col h-full"
    data-testid="exception-details-section"
  >
    <div class="text-neutral-900 font-semibold pb-2">Details</div>
    @if (processExceptionDetailsFC.value) {
      <flx-code-editor
        [options]="editorOptions"
        [readonly]="true"
        [warningsFooter]="{ show: false, expanded: false }"
        [formControl]="processExceptionDetailsFC"
        class="grow min-h-0"
      />
    }
  </div>
</div>

<ng-template
  #detailFieldTemplate
  let-detailField
>
  <ng-container>
    <div
      [ngClass]="{ 'items-center': detailField.field === 'build' }"
      [attr.data-testid]="'exception-detail-' + detailField.field"
      class="flex flex-row gap-x-2"
    >
      @if (detailField.header) {
        <div class="text-neutral-900 font-semibold">{{ detailField.header }}</div>
      }
      @if (processException()) {
        @switch (detailField.field) {
          @case ('processDefinitionName') {
            <span class="flex flex-row items-center gap-x-2">
              @if (processException().resourceDefinitionId && definitionsExist()) {
                <button
                  (click)="goToDefinition(processException(), applicationDetails())"
                  class="text-blue-500 font-semibold text-l inline-flex items-center p-0"
                  data-testid="go-to-process-definition-button"
                  flxButton
                  variant="text"
                >
                  <i class="ph ph-arrow-circle-up-right"></i>
                  Go to process definition
                </button>
              } @else {
                <span class="text-neutral-600">
                  {{
                    processException()[detailField.field] ||
                      processException()[detailField.secondaryField]
                  }}
                </span>
              }
              @if (!processException().resourceDefinitionId) {
                <span class="text-neutral-600">
                  {{
                    processException()[detailField.field] ||
                      processException()[detailField.secondaryField]
                  }}
                </span>
              }
            </span>
          }
          @case ('build') {
            <flx-build-tag
              [appName]="appName()"
              [buildTagVersion]="$safeNavigationMigration(applicationDetails()?.buildTag)"
              class="items-center"
            />
          }
          @case ('application') {
            <span class="text-neutral-900">
              {{ appName() || '' }}
            </span>
          }
          @case ('buildCreatedFrom') {
            <div class="flex flex-row items-center gap-x-2">
              <flx-branch-state-icon
                [status]="$safeNavigationMigration(processException()?.buildStatusAtStart)"
                [branchName]="$safeNavigationMigration(applicationDetails()?.branchName)"
                [branchOrder]="$safeNavigationMigration(applicationDetails()?.branchOrder)"
              />
              <flx-branch-name
                [branchName]="$safeNavigationMigration(applicationDetails()?.branchName)"
                [branchOrder]="$safeNavigationMigration(applicationDetails()?.branchOrder)"
              />
              @if (processException()?.buildStatusAtStart) {
                <flx-branch-state
                  [status]="$safeNavigationMigration(processException()?.buildStatusAtStart)"
                ></flx-branch-state>
              }
            </div>
          }
          @case ('applicationVersionId') {
            <span class="text-neutral-600"> {{ applicationDetails()?.buildId || '' }}</span>
          }
          @default {
            <span class="text-neutral-600">
              {{ processException()[detailField.field] || '-' }}</span
            >
          }
        }
      }
    </div>
  </ng-container>
</ng-template>
